export const boxStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
};

export const paperStyle = { width: '80%', maxWidth: '950px', padding: '1.5rem' };

export const adArea = {
  display: 'flex',
  justifyContent: '',
  marginTop: '1rem',
};

export const imageContainer = { flex: '50%', margin: '0rem .7rem 0rem 0rem' };

export const imageStyle = { height: 'auto', width: '100%' };

export const descriptionArea = { flex: '50%', margin: '0rem 0rem 0rem .7rem' };

export const bidContainer = { display: 'flex', margin: '.5rem', marginLeft: '0rem' };

export const bidButtonStyle = { height: '100%' };

export const adFormArea = {
  padding: '3rem',
  width: '50%',
  maxWidth: '950px',
  paddingTop: '2rem',
  display: 'flex',
  flexDirection: 'column',
};

export const formComponent = {
  marginTop: '1rem',
};

export const formTextField = {
  width: '100%',
};

export const formSubmitButtonContainer = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
};
